import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
`;

export const ContentContainer = styled.div`
  position: sticky;
  top: 1rem;
`;

export const ConfigContainer = styled.div`
  border: 1px solid #393939;
  border-radius: 0.25rem;
  padding: 1rem;
  width: 100%;
  display: flex;
  flex-direction: column;
  box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.15);
`;

export const Title = styled.p`
  font-size: 1.15rem;
  font-weight: 600;
  margin: 0;
`;

export const Spacer = styled.div`
  height: 0.5rem;
`;

export const ErrorContainer = styled.div`
  margin-top: 1rem;
  border: 1px solid #393939;
  background-color: rgba(255, 0, 0, 0.3);
  border-radius: 0.25rem;
  padding: 1rem;
  width: 100%;
  display: flex;
  flex-direction: column;
  box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.15);
`;

export const ErrorTitle = styled.p`
  margin: 0;
  font-size: 1.05rem;
  font-weight: 600;
  color: #ff0000;
`;

export const ErrorText = styled.p`
  margin: 0;
  margin-top: 1rem;
  font-size: 1rem;
  font-weight: 500;
  color: #ad0202;

  &::before {
    content: '• '
  }
`;